import { useState, useCallback } from "react";
import qs from "qs";
import {
  DRAWDOWN_TOOL_EVENTS,
  DT_URL_PARAMS,
} from "../../controls/DrawdownToolControl/constants/drawdownConstants";

/**
 * Hook for managing drawdown tool state and URL interactions
 * Provides crosshair cursor, URL parameter management, and tool state
 */
const useDrawdownTool = () => {
  const [isToolEnabled, setIsToolEnabled] = useState(false);

  const toggleTool = useCallback(() => {
    setIsToolEnabled((prev) => !prev);
  }, []);

  const disableTool = useCallback(() => {
    setIsToolEnabled(false);
  }, []);

  const clearDrawdownParams = useCallback(() => {
    const currentParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    // Remove all drawdown tool parameters
    Object.values(DT_URL_PARAMS).forEach((param) => {
      delete currentParams[param];
    });

    const newSearch = qs.stringify(currentParams, { addQueryPrefix: true });
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}${newSearch}`
    );

    // Notify listeners
    window.dispatchEvent(
      new CustomEvent(DRAWDOWN_TOOL_EVENTS.URL_PARAMS_CHANGED)
    );
  }, []);

  const setCoordinatesInUrl = useCallback(
    (coordinates) => {
      if (!isToolEnabled || !coordinates?.lat || !coordinates?.lon) return;

      const currentParams = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      });

      // Clear existing drawdown tool params
      delete currentParams[DT_URL_PARAMS.LAT];
      delete currentParams[DT_URL_PARAMS.LON];

      // Add new coordinates
      currentParams[DT_URL_PARAMS.LAT] = coordinates.lat.toString();
      currentParams[DT_URL_PARAMS.LON] = coordinates.lon.toString();

      const newSearch = qs.stringify(currentParams, { addQueryPrefix: true });
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}${newSearch}`
      );

      // Notify listeners
      window.dispatchEvent(
        new CustomEvent(DRAWDOWN_TOOL_EVENTS.URL_PARAMS_CHANGED)
      );

      // Auto-disable tool after use
      setIsToolEnabled(false);
    },
    [isToolEnabled]
  );

  return {
    isToolEnabled,
    toggleTool,
    disableTool,
    setCoordinatesInUrl,
    clearDrawdownParams,
  };
};

export default useDrawdownTool;
